import React from 'react';

type LoadingProps = {
  caption?: string
};

// The bouncing-dot keyframes + .bounces rules live in client/tailwind.css
// (keyframe sequences can't be utilities). `inline-flex flex-col justify-around`
// replaces the old wrapper layout.
export const Loading = (props: LoadingProps = {}) => (
  <div className="loading inline-flex flex-col justify-around">
    <div className="bounces">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
    {props.caption && <div className="caption text-center font-sans">{props.caption}</div>}
  </div>
);
